import MenuItem from '@mui/material/MenuItem'
import { FC, useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { Supplier } from '../../../../api/supplier/suppliers.types'
import { taxisAPI } from '../../../../api/vehicle/taxisAPI'
import { Taxi } from '../../../../api/vehicle/taxisAPI.types'
import FormSelect from '../../../FormFields/Select/FormSelect'

interface Item {
  value: string | number
  label: string
}

interface TaxiSelectProps {
  multiple?: boolean
}

const TaxiSelect: FC<TaxiSelectProps> = ({ multiple = false }) => {
  const [options, setOptions] = useState<Array<Item>>([])
  const supplier: Supplier = useSelector(
    (state: any) => state.suppliers.supplier,
  )
  const { data } = useQuery({
    queryKey: ['getTaxisBySupplierId', supplier.id],
    queryFn: async () => taxisAPI.getTaxisBySupplierId(supplier.id),
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (data) {
      let options: Item[] = []
      data.data.value.map((taxi: Taxi) => {
        console.log(taxi)
        options.push({
          value: taxi.id || 0,
          label: taxi.vehicleDetails?.vehicleTypeName,
        })
      })
      setOptions(options)
    }
  }, [data])

  return (
    <FormSelect
      name={multiple ? 'vehicleIds' : 'vehicleId'}
      placeholder="Taxi"
      label={multiple ? 'Taxis' : 'Taxi'}
      SelectProps={{ multiple }}
      allowEmpty={!multiple}
    >
      {options.map((option) => {
        return (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        )
      })}
    </FormSelect>
  )
}

export default TaxiSelect
